import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-shell" }
const _hoisted_2 = {
  key: 0,
  class: "idle-overlay"
}
const _hoisted_3 = { class: "idle-modal" }
const _hoisted_4 = { class: "idle-modal__title" }
const _hoisted_5 = { class: "idle-modal__desc" }
const _hoisted_6 = { class: "idle-modal__countdown" }
const _hoisted_7 = { class: "idle-modal__actions" }
const _hoisted_8 = {
  key: 0,
  class: "app-preloader"
}
const _hoisted_9 = { class: "app-preloader__content" }
const _hoisted_10 = { class: "app-preloader__text" }
const _hoisted_11 = {
  class: "main-content flex flex-col min-h-screen",
  id: "main-content"
}
const _hoisted_12 = { class: "flex-1 p-[12px] sm:p-[16px] md:p-[20px] lg:p-[25px]" }
const _hoisted_13 = {
  class: "main-content flex flex-col min-h-screen",
  id: "main-content"
}
const _hoisted_14 = { class: "flex-1 p-[12px] sm:p-[16px] md:p-[20px] lg:p-[25px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OfficeSidebar = _resolveComponent("OfficeSidebar")!
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_LeftSidebar = _resolveComponent("LeftSidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showWarning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "idle-modal__icon" }, [
                _createElementVNode("i", { class: "material-symbols-outlined" }, "lock_clock")
              ], -1)),
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("Sesi Akan Berakhir")), 1),
              _createElementVNode("p", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t("Anda tidak aktif. Sesi akan otomatis berakhir dalam")) + " ", 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(Math.floor(_ctx.countdown / 60)) + ":" + _toDisplayString(String(_ctx.countdown % 60).padStart(2, '0')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "idle-modal__btn idle-modal__btn--primary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stayLoggedIn && _ctx.stayLoggedIn(...args)))
                }, _toDisplayString(_ctx.$t("Tetap Login")), 1),
                _createElementVNode("button", {
                  class: "idle-modal__btn idle-modal__btn--secondary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.doLogout && _ctx.doLogout(...args)))
                }, _toDisplayString(_ctx.$t("Logout Sekarang")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "material-symbols-outlined app-preloader__icon" }, "sync", -1)),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("Memuat...")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOfficeRoute && !_ctx.isAuthRoute)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_OfficeSidebar),
          _createVNode(_component_TopHeader),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(), _createBlock(_component_router_view, {
                key: _ctx.$route.path
              }))
            ]),
            _createVNode(_component_MainFooter)
          ])
        ], 64))
      : (_ctx.isMitraRoute)
        ? (_openBlock(), _createBlock(_component_router_view, {
            key: _ctx.$route.path
          }))
        : (!_ctx.isAuthRoute && !_ctx.isPublicRoute)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createVNode(_component_LeftSidebar),
              _createVNode(_component_TopHeader),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(), _createBlock(_component_router_view, {
                    key: _ctx.$route.path
                  }))
                ]),
                _createVNode(_component_MainFooter)
              ])
            ], 64))
          : (_openBlock(), _createBlock(_component_router_view, { key: 4 }))
  ]))
}